import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/src/component/analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalytics"] */ "/vercel/path0/src/component/google-analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalProvider","GlobalModal"] */ "/vercel/path0/src/component/modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/component/react-query.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/vercel/path0/src/context/language-context.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/provider/hero.provider.tsx");
